<template>
    <div class="p-8">
        <div class="relative flex gap-4">
            <UInput
                v-model="search"
                variant="underline"
                autofocus
                size="xl"
                class="w-full"
                placeholder="جستجو"
                @keydown.enter="debouncedSearch"
                @input="debouncedSearch"
            />
            <UIcon
                :name="isLoading ? 'i-svg-spinners-90-ring-with-bg' : 'i-solar-magnifer-line-duotone'"
                class="top-1/2 left-1 absolute w-6 h-6 -translate-y-1/2"
            />
        </div>
        <div>
            <div v-if="isLoading" class="flex flex-col justify-center items-center gap-8 opacity-50 mt-12">
                <UIcon name="i-svg-spinners-90-ring-with-bg" class="w-16 h-16" />
                <UiComponentTypography>در حال جستجو</UiComponentTypography>
            </div>
            <div
                v-else-if="isNull(data) && isSearchEmpty"
                class="flex flex-col justify-center items-center gap-8 opacity-50 mt-12"
            >
                <UIcon name="i-solar-magnifer-line-duotone" class="w-16 h-16" />
                <UiComponentTypography> عبارت مورد نظر خود را جستجو کنید </UiComponentTypography>
            </div>
            <div
                v-else-if="!isNull(data) && isSearchEmpty"
                class="flex flex-col justify-center items-center gap-8 opacity-50 mt-12"
            >
                <UIcon name="i-solar-bill-cross-line-duotone" class="w-16 h-16" />
                <UiComponentTypography>
                    جستجو "{{ search }}" نتیجه‌ای نداشت، لطفا یک عبارت دیگر جستجو کنید.
                </UiComponentTypography>
            </div>
            <div v-else>
                <LazyUiSearchResult :data="data!" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { ISearchResult } from "~/libs/types/api/search";

const search = ref("");
const isLoading = ref(false);
const data: Ref<ISearchResult | null> = ref(null);

const debouncedSearch = useDebounceFn(() => {
    handleSearch();
}, 700);

async function handleSearch() {
    if (search.value.trim() === "") return;

    try {
        isLoading.value = true;
        data.value = null;
        const response = await fetchData(`/search?query=${encodeURIComponent(search.value)}`);
        if (!response) {
            throw new Error("Network response was not ok");
        }
        data.value = response.data;
    } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
    } finally {
        isLoading.value = false;
    }
}

const isSearchEmpty = computed(() => {
    if (isNull(data.value)) {
        return true;
    } else {
        if (isEmpty(data.value?.blogPosts) && isEmpty(data.value?.products) && isEmpty(data.value?.categories))
            return true;
    }
    return false;
});
</script>

<style></style>
